export default __webpack_public_path__ + "static/media/ccp_logo.97440f67.png";